/*eslint unicode-bom: ["error", "always"]*/
import './minicard.css'
import { LetterIcon } from '../icons/LetterIcon';
import { MiniCardProps } from './props/MiniCardProps';
import { MiniCardListProps } from './props/MiniCardListProps';


export const MiniCardList = ({ items = [] }:MiniCardListProps) => {

    return (
        <div className="short-list">
            {
                items.map((item, index) =>
                    <MiniCard
                        key={index}
                        item={item} />
                )
            }
        </div>
    );
}

export const MiniCard = ({ item, onClick, className = "" }:MiniCardProps) => {

    const handleOnClick = () => {
        if (!onClick) return;
        onClick();
    }

    return (
        <div
            onClick={handleOnClick}
            className={`short-list-item font-size-md ${className}`}
            style={{
                borderColor: item.borderColor,
            }}>
            <div className={`text-truncate`}>
                {`${item.text}`}
            </div>
            <div>
                {
                    isExaminer() &&
                    <LetterIcon letter="S" size="small" type="examiner" />
                }
                {
                    isAssignedAsTrainee() && !isTrainee() &&
                    <LetterIcon letter="L" size="small" type="trainee" />
                }
                {
                    isTrainee() &&
                    <LetterIcon letter="A" size="small" type="trainee" />
                }
            </div>
        </div>
    )

    function isExaminer() {
        if (!Object.hasOwn(item, "isExaminer")) return false;
        return item.isExaminer;
    }

    function isAssignedAsTrainee() {
        if (!Object.hasOwn(item, "isTrainee")) return false;
        return item.isTrainee;
    }

    function isTrainee() {
        if (!Object.hasOwn(item, "isApprentice")) return false;
        return item.isApprentice;
    }
}
